import { ReactElement } from 'react';
import { BaseHeaderProps } from '@localstack/types';
import { Box } from '@mui/material';

import { BaseHeaderBreadcrumbs } from '../../core';
import { SidebarIcon } from '../../display';
import { BaseHeaderActionsMenu, BaseTopMenu } from '../../navigation';
import { PlanChip } from '../../feedback/PlanChip';

import { BaseHeaderContainer } from './utils/styled-components';

export const BaseHeader = ({
  breadcrumbs,
  maturityLevel,
  links,
  dropdownActions,
  actions,
}: BaseHeaderProps): ReactElement => {
  return (
    <div>
      <BaseHeaderContainer className="base-header-container" px={2} py={1}>
        <SidebarIcon />
        <BaseHeaderBreadcrumbs items={breadcrumbs} />
        {maturityLevel && <PlanChip withStyles={false} planFamily={maturityLevel} showTooltip />}
        {dropdownActions && <BaseHeaderActionsMenu>{dropdownActions}</BaseHeaderActionsMenu>}
        <BaseTopMenu links={links} />
        {actions && <Box ml="auto">{actions}</Box>}
      </BaseHeaderContainer>
    </div>
  );
};
